import React from 'react';
import './index.less';

export default ({ displayStatus }: { displayStatus: boolean }) => {
    return (
        <div className="displayStatus">
            <div
                className="displayShow-box"
                style={{ background: displayStatus ? '#19be6b' : '#999999' }}
            />
            <div>{displayStatus ? '显示' : '隐藏'}</div>
        </div>
    );
};
